import mdaeNotify, { NOTIFY_MESSAGE_TYPE } from "./common_widgets/toast/notify";
const displayErrorMessage = (params) => {
  if (params && params.status === 401) {
  } else if (params && params.status === 500) {
    mdaeNotify({
      message: "Something went wrong on server",
      messageType: NOTIFY_MESSAGE_TYPE.ERROR,
    });
    if (params.responseBody && params.responseBody.ErrorCount > 0) {
    } else {
    }
  } else if (params.responseBody && params.responseBody.ErrorCount > 0) {
  }
};
export default displayErrorMessage;
